export default __webpack_public_path__ + "static/concerned-f5eb07476c190661e05dbb611362d827.svg";